/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'sarsaparilla';
import * as types from '../../constants';

const propTypes = {
    index: PropTypes.number.isRequired,
    handleMemberInfoChange: PropTypes.func.isRequired,
    division: PropTypes.object.isRequired,
    member: PropTypes.shape({
        passholderId: PropTypes.string,
        passholderType: PropTypes.string,
        email: PropTypes.string,
        alternateGroupLeaderId: PropTypes.string,
    }).isRequired,
    isDisabled: PropTypes.bool,
};

export default class FeeTypeInfo extends React.Component {
    constructor() {
        super();

        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handlePassNumberChange = this.handlePassNumberChange.bind(this);
    }

    handleTypeChange(e) {
        const value = e.target.value;
        const id = e.target.id;

        this.props.handleMemberInfoChange(this.props.index, id, value);
    }

    handlePassNumberChange(e) {
        const value = e.target.value;
        const id = e.target.id;

        this.props.handleMemberInfoChange(this.props.index, id, value);
    }

    showField() {
        const {
            member: { passholderType },
        } = this.props;
        return (
            passholderType === types.SEASON_CARD_FEE_TYPE ||
            passholderType === types.TREATY_CARD_FEE_TYPE ||
            passholderType === types.INTER_ACCESS_FEE_TYPE ||
            passholderType === types.INTER_SENIOR_FEE_TYPE ||
            passholderType === types.INTER_YOUTH_ACCESS_FEE_TYPE
        );
    }

    render() {
        const showPassIDField = this.showField();

        return (
            <div className="rec-nested-wrap">
                <div className="rec-grid-12-12">
                    <div className="rec-nested-wrap">
                        <div className="rec-grid-5-12">
                            <div className="rec-form-item-wrap">
                                <label htmlFor="memberPassholderType">
                                    Fee Type
                                    <mark title="required">*</mark>
                                </label>
                                <select
                                    value={this.props.member.passholderType}
                                    className="applyPassDropdown"
                                    id="memberPassholderType"
                                    disabled={this.props.isDisabled}
                                    onChange={this.handleTypeChange}
                                >
                                    <option value={types.ADULT_FEE_TYPE}>Adult</option>
                                    <option value={types.CHILD_FEE_TYPE}>
                                        Child/Youth
                                    </option>
                                    <option value={types.TREATY_CARD_FEE_TYPE}>
                                        Treaty Card Holder
                                    </option>
                                    <option value={types.INTER_ACCESS_FEE_TYPE}>
                                        Access Pass
                                    </option>
                                    <option value={types.INTER_SENIOR_FEE_TYPE}>
                                        Senior Pass
                                    </option>
                                    <option value={types.INTER_YOUTH_ACCESS_FEE_TYPE}>
                                        Youth Access Pass
                                    </option>
                                </select>
                            </div>
                        </div>
                        {showPassIDField && (
                            <div className="rec-grid-5-12">
                                <div className="rec-form-item-wrap">
                                    <TextField
                                        label="Physical Pass Number or Digital Pass Reservation Number"
                                        isRequired
                                        className="passIdInput"
                                        id="memberPassholderId"
                                        type="text"
                                        validator={(input) =>
                                            input ? { isValid: true } : { isValid: false }
                                        }
                                        shouldValidateOnMount
                                        value={this.props.member.passholderId || ''}
                                        onChange={this.handlePassNumberChange}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

FeeTypeInfo.propTypes = propTypes;
